export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";